import React from "react";
import { Link } from "react-router-dom";
import BrandMark from "./BrandMark";

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__top">
        <div className="site-footer__statement">
          <a href="/#top" aria-label="Crovian home"><BrandMark /></a>
          <p>Technology built to evolve.</p>
        </div>

        <div className="footer-column">
          <p className="footer-label">Business</p>
          <a href="/#business">Software Engineering</a>
          <a href="/#ai">Artificial Intelligence</a>
          <a href="/#business">Digital Products</a>
          <a href="/#capabilities">Technology Operations</a>
        </div>

        <div className="footer-column">
          <p className="footer-label">Company</p>
          <a href="/#company">About</a>
          <a href="/#work">Work</a>
          <a href="https://kailab.in/" target="_blank" rel="noopener noreferrer">KAI LAB</a>
          <a href="/#insights">Insights</a>
          <Link to="/contact">Contact</Link>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>© {new Date().getFullYear()} Crovian Technologies. All rights reserved.</p>
        <p>India · Working globally</p>
      </div>
    </footer>
  );
}
